<template>
    <div>
       <router-view></router-view>
    </div>
</template>

<script>
    export default {
        name: 'User',
    }
</script>


// WEBPACK FOOTER //
// src/pages/General/Users/index.vue